import { IonList } from '@ionic/react'
import airplane from '../../assets/images/airplane_icon.svg'
import activation from '../../assets/images/icons/activation.svg'
import portability from '../../assets/images/icons/portability.svg'
import referred from '../../assets/images/icons/referred.svg'
import { COUNTRY } from '../../const/constants'
import { useAppContext } from '../../context/AppContext'
import ProcedureLink from './ProcedureLink'

const ControlAccess = () => {
  const { settings, user, permissions }: any = useAppContext()
  const controlRender = () => (
    <>
      {(settings.country === COUNTRY.PY || settings.country === COUNTRY.UY) && (
        <ProcedureLink
          href={settings.procedures.referred.url}
          icon={referred}
          label={settings.procedures.referred.label}
          enabled={settings.procedures.referred.enabled}
        />
      )}
      {['pda', 'vd', 'vdi', 'vda', 'vna'].includes(user.profile) && (
        <>
          <ProcedureLink
            href={settings.procedures.portability.url}
            icon={portability}
            label={settings.procedures.portability.label}
            enabled={settings.procedures.portability.enabled}
          />

          {settings.country === COUNTRY.PY && (
            <ProcedureLink
              href={settings.procedures.activation.url}
              icon={activation}
              label={settings.procedures.activation.label}
              enabled={settings.procedures.activation.enabled}
            />
          )}
        </>
      )}
      {settings.country === COUNTRY.AR && (
        <>
          {permissions?.includes('Nominativity') && (
            <ProcedureLink
              href="/procedures/nominatividad"
              icon={airplane}
              label="Nominatividad extranjeros"
              enabled={false}
            />
          )}
        </>
      )}
    </>
  )

  return <IonList>{controlRender()}</IonList>
}

export default ControlAccess
